import { atom, useAtom } from 'jotai';

const sideNavAtom = atom(false);

export function useSideNav() {
  return useAtom(sideNavAtom);
}
